// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   전역 배율 설정 (노트북 대응)
   ======================================== */
html {
  font-size: 90%; /* 기본 100%에서 90%로 축소 - 노트북 대응 */
}

/* 이하 모두 모델설정 rjsf */

/* 기본 스타일 유지 */
.rjsf {
  margin-bottom: 16px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 1001;
  min-width: 500px;
  min-height: 600px;
}

/* 다크모드 - 기본 스타일 */
html.dark .rjsf {
  background-color: #1f2937;
  color: #f3f4f6;
}

/* 1) 텍스트 입력 필드 배경색 설정 */
.rjsf input[type="text"],
.rjsf input[type="number"],
.rjsf textarea {
  background-color: #f5f5f5;
  /* 옅은 회색 배경 */
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
  width: 30%;
}

/* 다크모드 - 텍스트 입력 필드 */
html.dark .rjsf input[type="text"],
html.dark .rjsf input[type="number"],
html.dark .rjsf textarea {
  background-color: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

/* 2) 선택 필드(select, radio, checkbox) 배경색 설정 */
.rjsf select {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
  max-width: 32;
  /* uiSchema에서 지정하는 widthClass 작동할 수 있게 할려면 이것을 주석처리함 */
}

/* 다크모드 - select 필드 */
html.dark .rjsf select {
  background-color: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

.rjsf .radio-inline,
.rjsf .checkbox-inline {
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 4px;
  display: inline-block;
}

/* 다크모드 - radio/checkbox */
html.dark .rjsf .radio-inline,
html.dark .rjsf .checkbox-inline {
  background-color: #374151;
}

/* 3) 텍스트 색상 구분 */
/* 타이틀 (라벨) */
.rjsf label {
  font-weight: 600;
  color: #2c3e50;
  /* 진한 파란빛 회색 */
  margin-bottom: 8px;
  display: block;
  /*font-size: 16px !important; */
}

/* 다크모드 - 라벨 */
html.dark .rjsf label {
  color: #93c5fd;
  /* 밝은 파란색 */
}

/* 입력/선택 필드 텍스트 */
.rjsf input[type="text"],
.rjsf input[type="number"],
.rjsf select,
.rjsf textarea {
  color: #333333;
  /* 진한 회색 */
}

/* 다크모드 - 입력/선택 필드 텍스트 */
html.dark .rjsf input[type="text"],
html.dark .rjsf input[type="number"],
html.dark .rjsf select,
html.dark .rjsf textarea {
  color: #f3f4f6;
}

/* 라디오/체크박스 옵션 텍스트 */
.rjsf .radio-inline span,
.rjsf .checkbox-inline span {
  color: #4a4a4a;
  /* 중간 톤의 회색 */
  font-weight: normal;
}

/* 다크모드 - 라디오/체크박스 옵션 텍스트 */
html.dark .rjsf .radio-inline span,
html.dark .rjsf .checkbox-inline span {
  color: #d1d5db;
}

/* 설명 텍스트 */
.rjsf .field-description {
  color: #666666;
  /* 밝은 회색 */
  font-size: 0.9em;
  margin-top: 4px;
  font-style: italic;
}

/* 다크모드 - 설명 텍스트 */
html.dark .rjsf .field-description {
  color: #9ca3af;
}

/* 도움말 텍스트 */
.rjsf .help-block {
  color: #888888;
  /* 더 밝은 회색 */
  font-size: 0.85em;
  margin-top: 4px;
}

/* 다크모드 - 도움말 텍스트 */
html.dark .rjsf .help-block {
  color: #6b7280;
}

/* 필수 필드 표시 (*) */
.rjsf label .required {
  color: #e74c3c;
  /* 빨간색 */
  margin-left: 2px;
}

/* 에러 메시지 */
.rjsf .error-detail {
  color: #e74c3c;
  /* 빨간색 */
  font-size: 0.9em;
  margin-top: 4px;
}

/* hover 효과 */
.rjsf input[type="text"]:hover,
.rjsf input[type="number"]:hover,
.rjsf select:hover,
.rjsf textarea:hover {
  background-color: #ebebeb;
  /* 호버 시 약간 더 진한 회색 */
}

/* 다크모드 - hover 효과 */
html.dark .rjsf input[type="text"]:hover,
html.dark .rjsf input[type="number"]:hover,
html.dark .rjsf select:hover,
html.dark .rjsf textarea:hover {
  background-color: #4b5563;
}

/* focus 효과 */
.rjsf input[type="text"]:focus,
.rjsf input[type="number"]:focus,
.rjsf select:focus,
.rjsf textarea:focus {
  background-color: #ffffff;
  /* 포커스 시 흰색 */
  border-color: #2196f3;
  /* 포커스 시 파란색 테두리 */
  outline: none;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
  /* 부드러운 포커스 효과 */
}

/* 다크모드 - focus 효과 */
html.dark .rjsf input[type="text"]:focus,
html.dark .rjsf input[type="number"]:focus,
html.dark .rjsf select:focus,
html.dark .rjsf textarea:focus {
  background-color: #1f2937;
  border-color: #60a5fa;
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.3);
}

/*  dbSettings 그룹 설정*/
select#root_dbSettings_dbmsType.form-control,
input#root_dbSettings_dbName.form-control,
input#root_dbSettings_schemaName.form-control,
select#root_systemSettings_systemName.form-control,
input#root_systemSettings_viewPrefix.form-control,
input#root_tableNameSettings_tableNamePrefix.form-control,
input#root_tableNameSettings_tableNameSuffix.form-control,
input#root_columnNameSettings_columnNamePrefix.form-control,
input#root_columnNameSettings_columnNameSuffix.form-control,
input#root_columnNameSettings_wordSeparator.form-control {
  width: 100% !important;
}

/* 스크롤바 스타일 - 다크모드 지원 */
.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar,
.rjsf::-webkit-scrollbar,
.overflow-auto::-webkit-scrollbar,
.flex-1[style*="overflow"]::-webkit-scrollbar,
.flex-1[style*="overflow"]>div::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-track,
.rjsf::-webkit-scrollbar-track,
.overflow-auto::-webkit-scrollbar-track,
.flex-1[style*="overflow"]::-webkit-scrollbar-track,
.flex-1[style*="overflow"]>div::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb,
.rjsf::-webkit-scrollbar-thumb,
.overflow-auto::-webkit-scrollbar-thumb,
.flex-1[style*="overflow"]::-webkit-scrollbar-thumb,
.flex-1[style*="overflow"]>div::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb:hover,
.rjsf::-webkit-scrollbar-thumb:hover,
.overflow-auto::-webkit-scrollbar-thumb:hover,
.flex-1[style*="overflow"]::-webkit-scrollbar-thumb:hover,
.flex-1[style*="overflow"]>div::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* 다크모드 - 스크롤바 */
html.dark .h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-track,
html.dark .rjsf::-webkit-scrollbar-track,
html.dark .overflow-auto::-webkit-scrollbar-track,
html.dark .flex-1[style*="overflow"]::-webkit-scrollbar-track,
html.dark .flex-1[style*="overflow"]>div::-webkit-scrollbar-track {
  background: #374151;
}

html.dark .h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb,
html.dark .rjsf::-webkit-scrollbar-thumb,
html.dark .overflow-auto::-webkit-scrollbar-thumb,
html.dark .flex-1[style*="overflow"]::-webkit-scrollbar-thumb,
html.dark .flex-1[style*="overflow"]>div::-webkit-scrollbar-thumb {
  background: #6b7280;
}

html.dark .h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb:hover,
html.dark .rjsf::-webkit-scrollbar-thumb:hover,
html.dark .overflow-auto::-webkit-scrollbar-thumb:hover,
html.dark .flex-1[style*="overflow"]::-webkit-scrollbar-thumb:hover,
html.dark .flex-1[style*="overflow"]>div::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* React Flow 드래그 중 커서 스타일 고정 (손 모양으로 일관되게 유지) */
.react-flow__node.dragging {
  cursor: grabbing !important;
}

/* 드래그 중 copy 커서(+) 제거 */
.react-flow__node.dragging * {
  cursor: grabbing !important;
}

/* ========================================
   그랩 모드 (Alt 키)
   ======================================== */

/* 그랩 모드 활성화 시 ReactFlow 전체 및 모든 하위 요소에 grab 커서 적용 */
.grabbing-mode,
.grabbing-mode *,
.grabbing-mode .react-flow__pane,
.grabbing-mode .react-flow__viewport,
.grabbing-mode .react-flow__renderer,
.grabbing-mode .react-flow__zoompane {
  cursor: grabbing !important;
}

/* 그랩 모드에서 드래그 중일 때 grabbing 커서 */
.grabbing-mode:active,
.grabbing-mode:active *,
.grabbing-mode .react-flow__pane:active {
  cursor: grabbing !important;
}

/* 그랩 모드에서 노드 위에서도 grab 커서 유지 */
.grabbing-mode .react-flow__node,
.grabbing-mode .react-flow__node * {
  cursor: grab !important;
}
/* ─────────────────────────────────────────────────────────────────────────────
   다크모드 스크롤바 — 전역 폴백
   위쪽 규칙은 \`.overflow-auto\` 처럼 특정 클래스만 지정해서, Tailwind 의
   \`overflow-y-auto\` / \`overflow-x-auto\` 를 쓰거나 인라인 스타일로 스크롤을 만드는
   영역(사이드바 엔터티 목록, 메모 textarea 등)은 브라우저 기본 흰 스크롤바가 그대로
   남았다. 어두운 화면에서 흰 막대로 튀므로 전역 폴백을 둔다.
   (개별 규칙이 더 구체적이라 위 설정은 그대로 우선 적용된다.)
   ───────────────────────────────────────────────────────────────────────────── */
html.dark ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

html.dark ::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

html.dark ::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 4px;
}

html.dark ::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

html.dark ::-webkit-scrollbar-corner {
  background: #1f2937;
}

/* Firefox */
html.dark * {
  scrollbar-color: #4b5563 #1f2937;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;6CAE6C;AAC7C;EACE,cAAc,EAAE,+BAA+B;AACjD;;AAEA,oBAAoB;;AAEpB,cAAc;AACd;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;;;EAGE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sDAAsD;AACxD;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;;EAEE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB,aAAa;AACb;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,cAAc;EACd,WAAW;AACb;;AAEA,iBAAiB;AACjB;;;;EAIE,cAAc;EACd,UAAU;AACZ;;AAEA,wBAAwB;AACxB;;;;EAIE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA,aAAa;AACb;;;;EAIE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;;;;EAIE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;;;;EAIE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;;;;;;;;;;EAUE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;;;;;EAKE,UAAU;EACV,WAAW;AACb;;AAEA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;AAC7B;;AAEA;;6CAE6C;;AAE7C,oDAAoD;AACpD;;;;;;EAME,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;;;EAGE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;;EAEE,uBAAuB;AACzB;AACA;;;;;;;kFAOkF;AAClF;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,gCAAgC;AAClC","sourcesContent":["/* ========================================\r\n   전역 배율 설정 (노트북 대응)\r\n   ======================================== */\r\nhtml {\r\n  font-size: 90%; /* 기본 100%에서 90%로 축소 - 노트북 대응 */\r\n}\r\n\r\n/* 이하 모두 모델설정 rjsf */\r\n\r\n/* 기본 스타일 유지 */\r\n.rjsf {\r\n  margin-bottom: 16px;\r\n  background-color: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  z-index: 1001;\r\n  min-width: 500px;\r\n  min-height: 600px;\r\n}\r\n\r\n/* 다크모드 - 기본 스타일 */\r\nhtml.dark .rjsf {\r\n  background-color: #1f2937;\r\n  color: #f3f4f6;\r\n}\r\n\r\n/* 1) 텍스트 입력 필드 배경색 설정 */\r\n.rjsf input[type=\"text\"],\r\n.rjsf input[type=\"number\"],\r\n.rjsf textarea {\r\n  background-color: #f5f5f5;\r\n  /* 옅은 회색 배경 */\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  width: 30%;\r\n}\r\n\r\n/* 다크모드 - 텍스트 입력 필드 */\r\nhtml.dark .rjsf input[type=\"text\"],\r\nhtml.dark .rjsf input[type=\"number\"],\r\nhtml.dark .rjsf textarea {\r\n  background-color: #374151;\r\n  border-color: #4b5563;\r\n  color: #f3f4f6;\r\n}\r\n\r\n/* 2) 선택 필드(select, radio, checkbox) 배경색 설정 */\r\n.rjsf select {\r\n  background-color: #f5f5f5;\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  max-width: 32;\r\n  /* uiSchema에서 지정하는 widthClass 작동할 수 있게 할려면 이것을 주석처리함 */\r\n}\r\n\r\n/* 다크모드 - select 필드 */\r\nhtml.dark .rjsf select {\r\n  background-color: #374151;\r\n  border-color: #4b5563;\r\n  color: #f3f4f6;\r\n}\r\n\r\n.rjsf .radio-inline,\r\n.rjsf .checkbox-inline {\r\n  background-color: #f5f5f5;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  margin-bottom: 4px;\r\n  display: inline-block;\r\n}\r\n\r\n/* 다크모드 - radio/checkbox */\r\nhtml.dark .rjsf .radio-inline,\r\nhtml.dark .rjsf .checkbox-inline {\r\n  background-color: #374151;\r\n}\r\n\r\n/* 3) 텍스트 색상 구분 */\r\n/* 타이틀 (라벨) */\r\n.rjsf label {\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  /* 진한 파란빛 회색 */\r\n  margin-bottom: 8px;\r\n  display: block;\r\n  /*font-size: 16px !important; */\r\n}\r\n\r\n/* 다크모드 - 라벨 */\r\nhtml.dark .rjsf label {\r\n  color: #93c5fd;\r\n  /* 밝은 파란색 */\r\n}\r\n\r\n/* 입력/선택 필드 텍스트 */\r\n.rjsf input[type=\"text\"],\r\n.rjsf input[type=\"number\"],\r\n.rjsf select,\r\n.rjsf textarea {\r\n  color: #333333;\r\n  /* 진한 회색 */\r\n}\r\n\r\n/* 다크모드 - 입력/선택 필드 텍스트 */\r\nhtml.dark .rjsf input[type=\"text\"],\r\nhtml.dark .rjsf input[type=\"number\"],\r\nhtml.dark .rjsf select,\r\nhtml.dark .rjsf textarea {\r\n  color: #f3f4f6;\r\n}\r\n\r\n/* 라디오/체크박스 옵션 텍스트 */\r\n.rjsf .radio-inline span,\r\n.rjsf .checkbox-inline span {\r\n  color: #4a4a4a;\r\n  /* 중간 톤의 회색 */\r\n  font-weight: normal;\r\n}\r\n\r\n/* 다크모드 - 라디오/체크박스 옵션 텍스트 */\r\nhtml.dark .rjsf .radio-inline span,\r\nhtml.dark .rjsf .checkbox-inline span {\r\n  color: #d1d5db;\r\n}\r\n\r\n/* 설명 텍스트 */\r\n.rjsf .field-description {\r\n  color: #666666;\r\n  /* 밝은 회색 */\r\n  font-size: 0.9em;\r\n  margin-top: 4px;\r\n  font-style: italic;\r\n}\r\n\r\n/* 다크모드 - 설명 텍스트 */\r\nhtml.dark .rjsf .field-description {\r\n  color: #9ca3af;\r\n}\r\n\r\n/* 도움말 텍스트 */\r\n.rjsf .help-block {\r\n  color: #888888;\r\n  /* 더 밝은 회색 */\r\n  font-size: 0.85em;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* 다크모드 - 도움말 텍스트 */\r\nhtml.dark .rjsf .help-block {\r\n  color: #6b7280;\r\n}\r\n\r\n/* 필수 필드 표시 (*) */\r\n.rjsf label .required {\r\n  color: #e74c3c;\r\n  /* 빨간색 */\r\n  margin-left: 2px;\r\n}\r\n\r\n/* 에러 메시지 */\r\n.rjsf .error-detail {\r\n  color: #e74c3c;\r\n  /* 빨간색 */\r\n  font-size: 0.9em;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* hover 효과 */\r\n.rjsf input[type=\"text\"]:hover,\r\n.rjsf input[type=\"number\"]:hover,\r\n.rjsf select:hover,\r\n.rjsf textarea:hover {\r\n  background-color: #ebebeb;\r\n  /* 호버 시 약간 더 진한 회색 */\r\n}\r\n\r\n/* 다크모드 - hover 효과 */\r\nhtml.dark .rjsf input[type=\"text\"]:hover,\r\nhtml.dark .rjsf input[type=\"number\"]:hover,\r\nhtml.dark .rjsf select:hover,\r\nhtml.dark .rjsf textarea:hover {\r\n  background-color: #4b5563;\r\n}\r\n\r\n/* focus 효과 */\r\n.rjsf input[type=\"text\"]:focus,\r\n.rjsf input[type=\"number\"]:focus,\r\n.rjsf select:focus,\r\n.rjsf textarea:focus {\r\n  background-color: #ffffff;\r\n  /* 포커스 시 흰색 */\r\n  border-color: #2196f3;\r\n  /* 포커스 시 파란색 테두리 */\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);\r\n  /* 부드러운 포커스 효과 */\r\n}\r\n\r\n/* 다크모드 - focus 효과 */\r\nhtml.dark .rjsf input[type=\"text\"]:focus,\r\nhtml.dark .rjsf input[type=\"number\"]:focus,\r\nhtml.dark .rjsf select:focus,\r\nhtml.dark .rjsf textarea:focus {\r\n  background-color: #1f2937;\r\n  border-color: #60a5fa;\r\n  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.3);\r\n}\r\n\r\n/*  dbSettings 그룹 설정*/\r\nselect#root_dbSettings_dbmsType.form-control,\r\ninput#root_dbSettings_dbName.form-control,\r\ninput#root_dbSettings_schemaName.form-control,\r\nselect#root_systemSettings_systemName.form-control,\r\ninput#root_systemSettings_viewPrefix.form-control,\r\ninput#root_tableNameSettings_tableNamePrefix.form-control,\r\ninput#root_tableNameSettings_tableNameSuffix.form-control,\r\ninput#root_columnNameSettings_columnNamePrefix.form-control,\r\ninput#root_columnNameSettings_columnNameSuffix.form-control,\r\ninput#root_columnNameSettings_wordSeparator.form-control {\r\n  width: 100% !important;\r\n}\r\n\r\n/* 스크롤바 스타일 - 다크모드 지원 */\r\n.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar,\r\n.rjsf::-webkit-scrollbar,\r\n.overflow-auto::-webkit-scrollbar,\r\n.flex-1[style*=\"overflow\"]::-webkit-scrollbar,\r\n.flex-1[style*=\"overflow\"]>div::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-track,\r\n.rjsf::-webkit-scrollbar-track,\r\n.overflow-auto::-webkit-scrollbar-track,\r\n.flex-1[style*=\"overflow\"]::-webkit-scrollbar-track,\r\n.flex-1[style*=\"overflow\"]>div::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb,\r\n.rjsf::-webkit-scrollbar-thumb,\r\n.overflow-auto::-webkit-scrollbar-thumb,\r\n.flex-1[style*=\"overflow\"]::-webkit-scrollbar-thumb,\r\n.flex-1[style*=\"overflow\"]>div::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb:hover,\r\n.rjsf::-webkit-scrollbar-thumb:hover,\r\n.overflow-auto::-webkit-scrollbar-thumb:hover,\r\n.flex-1[style*=\"overflow\"]::-webkit-scrollbar-thumb:hover,\r\n.flex-1[style*=\"overflow\"]>div::-webkit-scrollbar-thumb:hover {\r\n  background: #a1a1a1;\r\n}\r\n\r\n/* 다크모드 - 스크롤바 */\r\nhtml.dark .h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-track,\r\nhtml.dark .rjsf::-webkit-scrollbar-track,\r\nhtml.dark .overflow-auto::-webkit-scrollbar-track,\r\nhtml.dark .flex-1[style*=\"overflow\"]::-webkit-scrollbar-track,\r\nhtml.dark .flex-1[style*=\"overflow\"]>div::-webkit-scrollbar-track {\r\n  background: #374151;\r\n}\r\n\r\nhtml.dark .h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb,\r\nhtml.dark .rjsf::-webkit-scrollbar-thumb,\r\nhtml.dark .overflow-auto::-webkit-scrollbar-thumb,\r\nhtml.dark .flex-1[style*=\"overflow\"]::-webkit-scrollbar-thumb,\r\nhtml.dark .flex-1[style*=\"overflow\"]>div::-webkit-scrollbar-thumb {\r\n  background: #6b7280;\r\n}\r\n\r\nhtml.dark .h-\\[calc\\(100\\%-100px\\)\\]::-webkit-scrollbar-thumb:hover,\r\nhtml.dark .rjsf::-webkit-scrollbar-thumb:hover,\r\nhtml.dark .overflow-auto::-webkit-scrollbar-thumb:hover,\r\nhtml.dark .flex-1[style*=\"overflow\"]::-webkit-scrollbar-thumb:hover,\r\nhtml.dark .flex-1[style*=\"overflow\"]>div::-webkit-scrollbar-thumb:hover {\r\n  background: #9ca3af;\r\n}\r\n\r\n/* React Flow 드래그 중 커서 스타일 고정 (손 모양으로 일관되게 유지) */\r\n.react-flow__node.dragging {\r\n  cursor: grabbing !important;\r\n}\r\n\r\n/* 드래그 중 copy 커서(+) 제거 */\r\n.react-flow__node.dragging * {\r\n  cursor: grabbing !important;\r\n}\r\n\r\n/* ========================================\r\n   그랩 모드 (Alt 키)\r\n   ======================================== */\r\n\r\n/* 그랩 모드 활성화 시 ReactFlow 전체 및 모든 하위 요소에 grab 커서 적용 */\r\n.grabbing-mode,\r\n.grabbing-mode *,\r\n.grabbing-mode .react-flow__pane,\r\n.grabbing-mode .react-flow__viewport,\r\n.grabbing-mode .react-flow__renderer,\r\n.grabbing-mode .react-flow__zoompane {\r\n  cursor: grabbing !important;\r\n}\r\n\r\n/* 그랩 모드에서 드래그 중일 때 grabbing 커서 */\r\n.grabbing-mode:active,\r\n.grabbing-mode:active *,\r\n.grabbing-mode .react-flow__pane:active {\r\n  cursor: grabbing !important;\r\n}\r\n\r\n/* 그랩 모드에서 노드 위에서도 grab 커서 유지 */\r\n.grabbing-mode .react-flow__node,\r\n.grabbing-mode .react-flow__node * {\r\n  cursor: grab !important;\r\n}\n/* ─────────────────────────────────────────────────────────────────────────────\n   다크모드 스크롤바 — 전역 폴백\n   위쪽 규칙은 `.overflow-auto` 처럼 특정 클래스만 지정해서, Tailwind 의\n   `overflow-y-auto` / `overflow-x-auto` 를 쓰거나 인라인 스타일로 스크롤을 만드는\n   영역(사이드바 엔터티 목록, 메모 textarea 등)은 브라우저 기본 흰 스크롤바가 그대로\n   남았다. 어두운 화면에서 흰 막대로 튀므로 전역 폴백을 둔다.\n   (개별 규칙이 더 구체적이라 위 설정은 그대로 우선 적용된다.)\n   ───────────────────────────────────────────────────────────────────────────── */\nhtml.dark ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\nhtml.dark ::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\n\nhtml.dark ::-webkit-scrollbar-thumb {\n  background: #4b5563;\n  border-radius: 4px;\n}\n\nhtml.dark ::-webkit-scrollbar-thumb:hover {\n  background: #6b7280;\n}\n\nhtml.dark ::-webkit-scrollbar-corner {\n  background: #1f2937;\n}\n\n/* Firefox */\nhtml.dark * {\n  scrollbar-color: #4b5563 #1f2937;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
